import React from 'react'
import { IssuingAddFunding } from './issuingAddFunding'

export const IssuingAddFund = () => {
  return (
    <IssuingAddFunding />
  )
}
